import React from 'react'
import { BORG_WARNER_TROPHY } from '../driverPhotos'

/**
 * Decorative Borg-Warner trophy — absolute-positioned on the right side.
 * Parent container must have  position: relative  and  overflow: hidden.
 */
export default function BorgWarnerBackground() {
  return (
    <img
      src={BORG_WARNER_TROPHY}
      alt=""
      aria-hidden="true"
      style={{
        position:      'absolute',
        right:         0,
        top:           0,
        height:        '100%',
        width:         'auto',
        objectFit:     'cover',
        objectPosition:'top center',
        zIndex:        0,
        maskImage:     'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.45) 30%, rgba(0,0,0,0.75) 100%)',
        WebkitMaskImage:'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.45) 30%, rgba(0,0,0,0.75) 100%)',
        filter:        'brightness(0.45) saturate(0.65)',
        pointerEvents: 'none',
        userSelect:    'none',
      }}
    />
  )
}
